import { featureMap } from "@lib/help";
import { create } from "zustand";

const STORAGE_KEY = "dismissed_feature_badges";

type DismissedBadges = Record<string, string>;

export function loadDismissedBadges(): DismissedBadges {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      return JSON.parse(stored);
    }
  } catch {
    // ignore malformed data
  }
  return {};
}

function saveDismissedBadges(dismissed: DismissedBadges) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(dismissed));
}

type FeatureBadgeStore = {
  dismissed: DismissedBadges;
  dismissFeature: (id: string) => void;
};

export const useFeatureBadgeStore = create<FeatureBadgeStore>((set, get) => ({
  dismissed: loadDismissedBadges(),

  dismissFeature(id: string) {
    const feature = featureMap.get(id);
    if (!feature) return;

    const dismissed = { ...get().dismissed, [id]: feature.addedInVersion };
    saveDismissedBadges(dismissed);
    set({ dismissed });
  },
}));
